import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ontos_instance_rel_input = _resolveComponent("ontos-instance-rel-input")!
  const _component_create_instance_dialog = _resolveComponent("create-instance-dialog")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_ontos_instance_rel_input, {
      property: _ctx.property,
      items: _ctx.visibleItems,
      value: _ctx.selectValue,
      readonly: _ctx.readonly,
      loading: _ctx.loading,
      disabled: _ctx.loading,
      "force-multiple": _ctx.isMultiple,
      "allow-remove": !_ctx.protectedIds.length,
      "disabled-values": _ctx.disabledValues,
      "error-message": _ctx.errorMessage,
      hint: _ctx.blockedHint || _ctx.hint,
      creatable: _ctx.creatable,
      onInput: _ctx.onInput,
      onCreate: _ctx.openCreate
    }, null, 8, ["property", "items", "value", "readonly", "loading", "disabled", "force-multiple", "allow-remove", "disabled-values", "error-message", "hint", "creatable", "onInput", "onCreate"]),
    (_ctx.createContext)
      ? (_openBlock(), _createBlock(_component_create_instance_dialog, {
          key: 0,
          context: _ctx.createContext,
          initialName: _ctx.createName,
          "full-page": false,
          initialValues: _ctx.createValues,
          deferred: _ctx.isDeferred,
          "omit-properties": _ctx.isDeferred && _ctx.reverseInfo ? [_ctx.reverseInfo.reverse] : [],
          onShowMessage: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('showMessage', $event))),
          onSaved: _ctx.onCreated,
          onPending: _ctx.onPending,
          onClosed: _cache[1] || (_cache[1] = ($event: any) => (_ctx.createContext = null))
        }, null, 8, ["context", "initialName", "initialValues", "deferred", "omit-properties", "onSaved", "onPending"]))
      : _createCommentVNode("", true)
  ]))
}